module.exports = __webpack_public_path__ + "img/slide2.1b4196f2.png";